import { groq } from "next-sanity";
import { Meetups } from "../common/types";
import { getClient } from "../lib/sanity.server";
import MeetupsScreen from "../view/screens/Meetups/Meetups";

export default function BlogPage({ meetups }: { meetups: Meetups[] }) {
    return <MeetupsScreen meetups={meetups} />;
}

export async function getStaticProps() {
    const meetups: Meetups[] = await getClient().fetch(
        groq`
      *[_type == "meetup"] {
        _id,
        title,
        slug,
        link,
        mainImage,
        tags[]->{
          _id,
          title,
          slug
        },
        city ->{
          name,
          image,
          title,
          slug
        },
        date,
        publishedAt,
        body
      } | order(date desc)
      `
    );

    return {
        props: {
            meetups,
        },
        revalidate: 10,
    };
}
